import { useEffect } from "react";

// Accomodate for Anroid Chrome's bottom/URL bar
// Handle viewport height changes
// The visual here gives a good indication: https://dev.to/ozanbolel/fit-your-website-to-the-viewport-on-mobile-38hl

const useViewportHeight = (cssVarName = "--botbrains-vh") => {
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty(cssVarName, `${vh}px`);
    };

    setVH();

    window.addEventListener("resize", setVH);
    window.addEventListener("orientationchange", setVH);
    return () => {
      window.removeEventListener("resize", setVH);
      window.removeEventListener("orientationchange", setVH);
    };
  }, []);
};

export default useViewportHeight;
